import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ChequePaymentMethod = ({
  index,
  total,
  onAmountChange,
  enteredAmountCheque,
  maxAmount,
  tel,
  setTel,
  num,
  setNumCheque,
  echeance,
  setEcheance,
}: any) => {

    const [givenAmountCheque, setGivenAmountCheque] = useState<string | null>(null);


  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const amount = e.target.value;
    if (/^\d*\.?\d*$/.test(amount)) {
      if (amount === "") {
        setGivenAmountCheque(amount);
        onAmountChange(null); // Update the parent state
        return;
      }
      const parsed = Number(amount);
      const clamped =
        !isNaN(parsed) && typeof maxAmount === "number"
          ? Math.min(parsed, Math.max(0, maxAmount))
          : parsed;
      const clampedStr = isNaN(clamped) ? amount : String(clamped);
      setGivenAmountCheque(clampedStr); // Store the (possibly clamped) value
      onAmountChange(isNaN(clamped) ? 0 : clamped); // Update the parent state
    }

  };

  const { t } = useTranslation();

  return (
    <div className="navbar-item flex-row search-ul navbar-dropdown">
      <div className="nav-item align-self-center search-animated">
        <h6 className="mb-2" onClick={()=>console.log(index)}>{"Chéque n " +index}</h6>
        <form
          className="form-inline search-full form-inline search"
          role="search"
        >
          <div className="row" style={{ width: "100%" }}>
            <div className="col-6">
              {" "}
              <div className="search-bar" style={{ marginBottom: "7px" }}>
                <input
                  type="text"
                  className="form-control search-form-control  ml-lg-auto"
                  placeholder={t("Numéro de cheque")}
                  value={num}
                  onChange={(e) => setNumCheque(e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              {" "}
              <div className="search-bar" style={{ marginBottom: "7px" }}>
                <input
                  type="date"
                  className="form-control search-form-control ml-lg-auto"
                  placeholder="date d'echeance"
                  value={echeance}
                  min={new Date().toISOString().split("T")[0]} // sets min date to today
                  onChange={(e) => setEcheance(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row" style={{ width: "100%" }}>
            <div className="col-6">
              {" "}
              <div className="search-bar" style={{ marginBottom: "7px" }}>
                <input
                  type="text"
                  className="form-control search-form-control  ml-lg-auto"
                  value={
                 

                      enteredAmountCheque > 0
                      ? enteredAmountCheque
                      : givenAmountCheque !== null
                      ? givenAmountCheque
                      : givenAmountCheque
                  }
                  placeholder={t("amount")}
                  onChange={handleAmountChange}
                />
              </div>
            </div>
            <div className="col-6">
              {" "}
              <div className="search-bar" style={{ marginBottom: "7px" }}>
                <input
                  type="text"
                  className="form-control search-form-control  ml-lg-auto"
                  placeholder={t("Tél")}
                  value={tel}
                  onChange={(e) => setTel(e.target.value)}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <hr></hr>
    </div>
  );
};

export default ChequePaymentMethod;
